import { render, staticRenderFns } from "./ShiCiDetails.vue?vue&type=template&id=2f8242d4&scoped=true&"
import script from "./ShiCiDetails.vue?vue&type=script&lang=js&"
export * from "./ShiCiDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShiCiDetails.vue?vue&type=style&index=0&id=2f8242d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8242d4",
  null
  
)

export default component.exports